import React from 'react'

function getYouTubeId(rawUrl) {
  try {
    const url = new URL(rawUrl)
    const host = url.hostname.replace(/^www\./, '')

    if (host === 'youtu.be') return url.pathname.split('/').filter(Boolean)[0] || null
    if (!host.endsWith('youtube.com')) return null

    if (url.pathname === '/watch') return url.searchParams.get('v')
    const [, type, id] = url.pathname.split('/')
    if (['embed', 'shorts', 'live'].includes(type)) return id || null
    return null
  } catch {
    const match = rawUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/)
    return match ? match[1] : null
  }
}

function getVimeoId(rawUrl) {
  try {
    const url = new URL(rawUrl)
    if (!url.hostname.includes('vimeo.com')) return null
    const parts = url.pathname.split('/').filter(Boolean)
    return parts.find(part => /^\d+$/.test(part)) || null
  } catch {
    const match = rawUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/)
    return match ? match[1] : null
  }
}

export default function VideoEmbed({ url }) {
  const ytId = getYouTubeId(url)
  const vimeoId = getVimeoId(url)

  if (!ytId && !vimeoId) return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="timeline-link">Link: {url}</a>
  )

  const src = ytId
    ? `https://www.youtube-nocookie.com/embed/${ytId}?rel=0&modestbranding=1`
    : `https://player.vimeo.com/video/${vimeoId}`

  return (
    <div className="video-embed-wrap">
      <iframe
        src={src}
        title={ytId ? 'YouTube video' : 'Vimeo video'}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        referrerPolicy="strict-origin-when-cross-origin"
        className="video-embed-iframe"
      />
    </div>
  )
}
